import { render, staticRenderFns } from "./SearchResults.vue?vue&type=template&id=0421326c&scoped=true"
import script from "./SearchResults.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchResults.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SearchResults.vue?vue&type=style&index=0&id=0421326c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0421326c",
  null
  
)

export default component.exports